import { useState, type FC } from "react";
import Modal from "../Modal";
import Alert from "../Alert";
import Lookup from "../../organisms/Lookup";
import SmallLoadingSpinner from "../../atoms/SmallLoadingSpinner";
import { useTranslation } from "react-i18next";
import { useConnectInvoiceUploadUnitToClient } from "../../../graphql/hooks/documentHandler/useConnectInvoiceUploadUnitToClientIdentifier";

type Props = {
  uploadUnitId: string;
};

const ConnectUploadUnitToClientViaLookup: FC<Props> = ({ uploadUnitId }) => {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState("");

  const onCompletedConnectToClient = (response: any) => {
    if (
      response?.documentHandler?.connectInvoiceUploadUnitToClientIdentifier
        ?.success === true
    ) {
      setErrorMessage("");
    } else {
      setErrorMessage(t("errors.somethingWentWrong"));
    }
  };
  const onErrorConnectToClient = () => {
    setErrorMessage(t("errors.somethingWentWrong"));
  };

  const { connectInvoiceUploadUnitToClient, loading, error } =
    useConnectInvoiceUploadUnitToClient({
      onCompleted: onCompletedConnectToClient,
      onError: onErrorConnectToClient,
    });

  const onClickConnectCompany = async (clientIdentifier: string) => {
    try {
      await connectInvoiceUploadUnitToClient({
        variables: {
          input: {
            clientIdentifier: clientIdentifier,
            uploadUnitId: uploadUnitId,
          },
        },
      });
    } catch (error) {
      setErrorMessage(t("errors.somethingWentWrong"));
    }
  };

  const onSelectLookupResult = (item: any) => {
    onClickConnectCompany(item?.clientIdentifier);
  };

  return (
    <div>
      {loading ? (
        <SmallLoadingSpinner />
      ) : (
        <Lookup
          type="dropdownSmall"
          onClickResult={onSelectLookupResult}
          placeholder={t("documentHandler.connectUploadUnitToClient")}
          displayOnlyIssuer
        />
      )}

      {errorMessage && (
        <Modal onClose={() => setErrorMessage("")} closeIcon>
          {errorMessage && (
            <Alert
              type="error"
              title={errorMessage}
              message={error?.toString()}
            />
          )}
        </Modal>
      )}
    </div>
  );
};

export default ConnectUploadUnitToClientViaLookup;
